import React from "react";
import { useUsersContext } from "../../contexts/users.tsx";
import IsNullOrEmpty from "../../models/helpers/isNullOrEmpty.ts";
import { useNavigate } from "react-router-dom";
import FormButton from "./FormButton.tsx";

const FormActions = ({
    children,
    mainAction,
    mainActionText,
    secondaryAction,
    secondaryActionText,
    showCancelButton = false,
    overrideIsLoggedIn = false
}: {
    children?: any,
    mainAction?: any,
    mainActionText?: any,
    secondaryAction?: any,
    secondaryActionText?: any,
    showCancelButton?: boolean
    overrideIsLoggedIn?: boolean
}) => {
    const { isLoggedIn } = useUsersContext();
    const navigate = useNavigate();
    const handleGoBack = () => {
        navigate(-1);
    };
    return (
        (isLoggedIn || overrideIsLoggedIn) &&
        <div className="bg-body-tertiary fixed-bottom">
            <div className="d-flex justify-content-between p-3 maxw-1920">
                {
                    mainAction &&
                    <FormButton text={!IsNullOrEmpty(mainActionText) ? mainActionText : "Submit"} onClick={mainAction} color="success" />
                }
                {
                    secondaryAction &&
                    <FormButton text={!IsNullOrEmpty(secondaryActionText) ? secondaryActionText : "Cancel"} onClick={secondaryAction} color="secondary" />
                }
                {
                    !secondaryAction && showCancelButton &&
                    <FormButton text="Cancel" onClick={handleGoBack} color="secondary" />
                }
                {children}
            </div>
        </div>
    )
}

export default FormActions;